module.exports = __webpack_public_path__ + "static/img/装饰4.cdeea65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/装饰4.svg
// module id = 3Fb/
// module chunks = 2